import { IMunicipality } from '../../../models/municipality.model';
import municipalityIcon from '../../../../assets/icons/municipality-dark.svg';
import { TranslationService } from '../../../services/translation.service';

function MunicipalityListShowcase({ municipalities }: { municipalities: IMunicipality[] }) {
  return (
    <div className="municipality-list-showcase w-100">
      {municipalities.map((item) => (
        <div key={item.gid} className="d-flex align-items-center">
          <div className="municipality-list-showcase__icon flex-shrink-0 mx-1">
            <img src={municipalityIcon} alt="" />
          </div>
          <div className="municipality-list-showcase__municipality py-1 px-1 flex-shrink-0 text-center me-2">
            <span className="visually-hidden">{TranslationService.get('common.municipality')}</span>
            {item.name}
          </div>
        </div>
      ))}
    </div>
  );
}

export default MunicipalityListShowcase;
